import { Box, useTheme } from "@mui/material";
import { FC, PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";
import { NavigationMenu } from "./navigation/NavigationMenu";

export interface IDefaultLayoutProps extends PropsWithChildren {

}

const DefaultLayout: FC<IDefaultLayoutProps> = ({ children }) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                display: "flex",
                width: "100%"
            }}
        >
            <NavigationMenu />
            <Box
                sx={{
                    flexGrow: 1,
                    width: "80%"
                }}
            >
                <Box 
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        padding: theme.spacing(0, 1),
                        // necessary for content to be below app bar
                        ...(theme.mixins.toolbar as any),
                        minHeight: `${theme.spacing(8)} !important`
                    }}
                />
                <Box sx={{
                    padding: theme.spacing(3)
                }}>
                    <Outlet />
                    {children}
                </Box>
            </Box>
        </Box>
    );
}

export default DefaultLayout;